export default "__VITE_ASSET__DmF_Vxmy__"